<template>
  <div class="login">
    <div class="content">
      <img src="../assets/logo.png" alt="NxGen Logo" />
      <div class="form">
        <label for="username">Username</label>
        <input
          type="text"
          v-model="username"
          placeholder="enter your username here"
        />
        <label for="phone">Phone</label>
        <input
          type="text"
          v-model="phone"
          placeholder="enter your phone number here"
        />
        <button @click="login">Login</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  methods: {
    username: "",
    phone: "",
  },
  methods: {
    login() {
      if (!this.username || this.username == "") {
        this.$Notifications.showNotification(
          "danger",
          "Please enter your username"
        );
        return;
      }

      if (!this.phone || this.phone == "") {
        this.$Notifications.showNotification(
          "danger",
          "Please enter your phone"
        );
        return;
      }
      this.$Notifications.showLoading();

      this.$HTTP
        .post(this.$URLS.AUTH.LOGIN, {
          username: this.username,
          phone: this.phone,
        })
        .then((data) => {
          console.log("LOGIN RESPONSE");
          console.log(data);
          localStorage.setItem("rider_username", data.data.rider.username);
          localStorage.setItem("rider_token", data.data.rider.token);
          this.$Notifications.hideLoading();
          this.$Notifications.showNotification("success", "Login successful");
          this.$router.push("/home");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 80vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 80%;
      margin-bottom: 10rem;
    }

    .form {
      width: 100%;

      label {
        width: 100%;
        font-size: 1.2rem;
        font-family: "P-600";
        color: var(--clr-ylw);
        text-transform: uppercase;
      }

      input {
        width: 100%;
        background: transparent;
        height: 4rem;
        border: none;
        border-bottom: 0.1rem solid lightgray;
        outline: none;
        font-size: 1.4rem;
        font-family: "P-400";
        margin-bottom: 2rem;
        color: black;
      }
    }
  }
}
</style>